import { render } from "./gtrPointsSummary.vue?vue&type=template&id=0e442542&ts=true"
import script from "./gtrPointsSummary.vue?vue&type=script&lang=ts"
export * from "./gtrPointsSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__